import React, { PropsWithChildren } from 'react';
import { Nullable } from 'global';
import FilterListIcon from '@mui/icons-material/FilterList';
import { TableFilter } from '@trnsact/trnsact-shared-types';
import { checkIfTabIsStandard } from 'modules/vendorOpportunity/list/lib';
import { Button, FormGroup, FormControlLabel, Switch, Paper } from '@mui/material';

import { TABS_WITHOUT_DEFAULT_SWITCH } from '../../../constants';

interface Props {
  filtersAmount: number;
  currentTabValue: string;
  onFiltersClick: VoidFunction;
  onSetAsDefaultClick: VoidFunction;
  defaultFilter?: Nullable<TableFilter>;
  isSetDefaultTableFilterLoading: boolean;
}

export const TabsWrapper = ({
  children,
  defaultFilter,
  filtersAmount,
  onFiltersClick,
  currentTabValue,
  onSetAsDefaultClick,
  isSetDefaultTableFilterLoading,
}: PropsWithChildren<Props>) => {
  const isCurrentTabDefault = defaultFilter?.tableFilterId === currentTabValue;
  const isCurrentTabIsStandard = checkIfTabIsStandard(currentTabValue);
  const isTabWithoutDefaultSwitch = TABS_WITHOUT_DEFAULT_SWITCH.includes(currentTabValue);

  return (
    <Paper elevation={0} sx={{ display: 'flex', alignItems: 'center' }}>
      <Button
        onClick={onFiltersClick}
        startIcon={<FilterListIcon />}
        sx={{ marginRight: '1rem', whiteSpace: 'nowrap' }}
      >
        {`Filters ${filtersAmount}`}
      </Button>

      {children}

      {!isCurrentTabIsStandard && !isTabWithoutDefaultSwitch && (
        <FormGroup sx={{ marginLeft: 'auto' }}>
          <FormControlLabel
            label="Set as Default Tab"
            control={
              <Switch
                onClick={onSetAsDefaultClick}
                checked={isCurrentTabDefault}
                disabled={isSetDefaultTableFilterLoading}
              />
            }
          />
        </FormGroup>
      )}
    </Paper>
  );
};
